import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Box,
  Button,
  Divider,
  MenuItem,
  Modal, 
  TextField, 
  Typography
} from '@mui/material';

import LoadingButton from '../../../../../../components/buttons/Button';

import { 
  CreatePaymentCountryBIZcoreCC, 
  UpdatePaymentCountryBIZcoreCC
} from '../../../../../../redux/actions/business/core/currencyCloudActions';

import global from "../../../../../../global.scss";

const Data = {
  Name: "",
  Code: "",
  Country: ""
};

const PaymentCountriesModal = ({
  open, 
  setOpen, 
  title,
  update,
  handleGet
}) => {
  const dispatch = useDispatch();
  const state = useSelector(state => state["business.core.cc"]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);
  const [mode, setMode] = useState(1);

  const [countriesList, setCountriesList] = useState([]);

  const handleClose = () => {

    setOpen(false);
    setFormData(Data);
    setMode(1);
  }

  useEffect(() => {
    try {
      if(open){
        if(update.defaultMode === 1){
          // mode = 1 - create payment country
          setMode(1);
        }else if(update.defaultMode === 2){
          // mode = 2 - edit payment country
          setMode(2);
          setFormData({
            ...formData,
            Name: update.name || "",
            Code: update.code || "",
            // the API nests the FK object; the select is keyed on its id
            Country: update.ref_country_id?.id || "",
          });
        }else{
          toast.error("Invalid modal");
          handleClose();
        }
      }
    } catch (err) {
      console.log(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    try {
      formatCountriesList(state.countriesList.records || []);
    } catch (err) {}
  }, [state]);

  // Sorted by name — the raw API order is insertion order, which makes a
  // 250-entry dropdown unusable.
  const formatCountriesList = (list) => {
    setCountriesList([...list].sort((a, b) => (a.name || "").localeCompare(b.name || "")));
  };  

  // --------------- handle change ----------------
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if(mode === 1){
      // create country
      let obj = {
        ref_country_id: formData.Country || "",
      };
      dispatch(CreatePaymentCountryBIZcoreCC(obj, setLoading)).then(() => {
        handleGet(setLoading).then(() => {
          handleClose();
        })
      });
    }else if(mode === 2){
      // update country
      let obj = {
        ref_country_id: formData.Country || "",
      };
      dispatch(UpdatePaymentCountryBIZcoreCC(update.id, obj, setLoading)).then(() => {
        handleGet(setLoading).then(() => {
          handleClose();
        })
      });
    }else{
      toast.error("Invalid modal");
      handleClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow"
        width={"100vw"} height={"100vh"}>
        <Box maxWidth={"sm"} className="modal">
          <Box width={"100%"}
            sx={{ padding: "15px"}}>
            <Typography variant='h6' 
              sx={{ color: global["primary"] }} mb={"20px"}>
              {title}
            </Typography>
            <Box 
              className="flexCenterSBRow"
              gap={"15px"}
              mb={"15px"}>
              <TextField 
                select
                label="CC Countries"
                fullWidth
                name="Country"
                value={formData.Country}
                onChange={handleChange}
                inputProps={{ maxLength: 64 }}
                >
                {
                  countriesList.map((item, index) => (
                    <MenuItem
                      key={index}
                      value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))
                }
              </TextField>
            </Box>
          </Box>
          <Divider
            sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }}/>
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px"}}>
            <Button variant='text'
              onClick={handleClose}>
              Cancel
            </Button>
            <LoadingButton 
              variant='contained'
              loading={loading}
              disabled={!(formData.Country !== "")}
              onClick={handleSubmit}>
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default PaymentCountriesModal;